// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
// import axiosXendit from 'axios'
// import VueSimpleAlert from "vue-simple-alert";
// import Swal from 'vue-sweetalert2';
// import App from './App.vue';

// Vue.use(Swal);
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'


import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import tinymce from '@tinymce/tinymce-vue';
import { VuejsDatatableFactory } from 'vuejs-datatable';

import number from 'vue-number-format'

import AxiosPlugin from 'vue-axios-cors';

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
 
Vue.use(AxiosPlugin)

// register directive v-number and component <number>
Vue.use(number, {precision: 0, prefix: ''})
// const app = createApp(App);

Vue.use(VueSweetalert2);
Vue.use(Vuetify);
Vue.use(tinymce);
Vue.component('v-select', vSelect);
Vue.component('tinymce', tinymce);
Vue.use( VuejsDatatableFactory );

import VueMathjax from 'vue-mathjax'
Vue.use(VueMathjax);

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import LazyTube from "vue-lazytube";
Vue.use(LazyTube);

import VirtualList from "vue-virtual-scroll-list";
Vue.component("virtual-list", VirtualList);

import VirtualTable from 'vue-virtual-table';
Vue.use(VirtualTable);

// import VueYouTubeEmbed from 'vue-youtube-embed'
// Vue.use(VueYouTubeEmbed)

// import LazyYoutubeVideo from 'vue-lazy-youtube-video'
 
// Vue.use(LazyYoutubeVideo)

// import { RingBottomNavigation } from "bottom-navigation-vue";

// Vue.use(RingBottomNavigation);

// import VueMobileDetection from 'vue-mobile-detection'
// Vue.use(VueMobileDetection)

// var mixinDetictingMobile = {
// 	methods: {
//   	isMobile: function() {
//     	var check = false;
//   (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
//   return check;
//     }
//   }
// }

// window.Swal =  Vue.config.globalProperties.$swal;

// import swal from 'sweetalert2';
// window.Swal = VueSweetalert2;


import { setHeaderToken, removeHeaderToken } from './utils/auth'

import LayoutHeader from '@/components/Layout/HeaderMain'
import LayoutHeaderLogin from '@/components/Layout/HeaderLogin'
import LayoutFooter from '@/components/Layout/Footer'
let bootstrap = require('bootstrap')
import 'bootstrap/dist/css/bootstrap.css'
import './assets/fontawesome/css/fontawesome.min.css'
import './assets/fontawesome/css/all.min.css'
import './assets/css/style.css'
// import 'vue-lazy-youtube-video/dist/style.css'

import VueSlick from 'vue-slick'
// import AOS from 'aos'
// import 'aos/dist/aos.css'
// import 'dtoaster/dist/dtoaster.css'
// import DToaster from 'dtoaster'
// Vue.use(DToaster, {
//   // presets: ToasterPresets,
//   position: 'top-right', //toasts container position on the screen
//   containerOffset: '45px', //toasts container offset from top/bottom of the screen
// })
// import FlashMessage from '@smartweb/vue-flash-message';

// const props = {
//     position: 'fixed',
//     width: '20vw',
//     placement: 'top',
//     successText: '#2e8441',
//     successBackground: '#e0dc68',
//     successBorder: '#52cc6d'
// }


axios.defaults.baseURL = 'https://api.pejuangpendidik.com/';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axiosXendit.defaults.baseURL = 'https://api.xendit.co/v2/'

const token = localStorage.getItem('token');

if (token) { 
  setHeaderToken(token) 
} 


// const config = {
// 	name: 'flashMessage',
// 	tag: 'FlashMessage',
// 	time: 8000
// };

// Vue.use(VueSimpleAlert);
Vue.component('layout-header', LayoutHeader)
Vue.component('layout-header-login', LayoutHeaderLogin)
Vue.component('layout-footer', LayoutFooter)
Vue.component('slick', VueSlick)
Vue.config.productionTip = false
Vue.config.devtools = false

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

// Vue.mixin({
//   created: function () {
//     // console.log('mixin hook called');
//     if(localStorage.getItem('token')){
//       store.dispatch("checktoken");
//     }
//     // var myOption = localStorage.getItem("IdUser");
//     // if (myOption) {
//     //   console.log("ini mixin: " +myOption);
//     // }
//   }
// });
// var mixin = {
//   created: function () {
//     console.log('mixin hook called')
//   }
// }


window.swal = require('sweetalert2')
store.dispatch('get_user', token)
.then(() => {
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    render: h => h(App)
  }).$mount('#app')
}).catch((error) => {
  console.error(error);
});


// Vue.use(FlashMessage);

$(document).ready(function() {
  // $('body').bind('cut copy', function(e) {
  //     e.preventDefault();
  // });
  $(document).bind('mousedown selectstart', function(e) {
      return $(e.target).is('input, textarea, select, option, html');
  });
  // const disableselect = (e) => {  
  //     return false  
  // }  
  // document.onselectstart = disableselect  
  // document.onmousedown = disableselect
  $(document).bind("contextmenu",function(e){
      return false;
  });
  document.onkeydown = function(e) {
    if(event.keyCode == 123) {
       return false;
    }
    // if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
    //    return false;
    // }
    if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
       return false;
    }
    if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
       return false;
    }
    if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
       return false;
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js